import script from "./HighChart3.vue?vue&type=script&setup=true&lang=js"
export * from "./HighChart3.vue?vue&type=script&setup=true&lang=js"

import "./HighChart3.vue?vue&type=style&index=0&id=3594afae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3594afae"]])

export default __exports__